import React from "react"
import core1 from "../../assets/images/about/core1.svg"
import core2 from "../../assets/images/about/core2.svg"
import core3 from "../../assets/images/about/core3.svg"

const CoreValues = () => {
  return (
    <div className="row core-value-area">
      <div className="col">
        <h3 className="heading-2">Our Core Values</h3>
        <div className="core-value-wrapper">
          <div className="core-value">
            <img src={core1} alt="core value icon" />
            <div>
              {" "}
              <h5 className="core-value-title">Performance</h5>
              <p className="paragraph-3">
                We get you the fastest pre-approval that's possible. And we
                always recommend the home loan that's right for you. Whichever
                bank offers it. Because we work on your behalf not the banks,
                you get the most competitive rate every time. And we do it fast,
                at no cost to you – our service is free. That is a really fresh
                promise in home finance.
              </p>
            </div>
          </div>
          <div className="core-value">
            <img src={core2} alt="core value icon" />
            <div>
              <h5 className="core-value-title">Integrity</h5>
              <p className="paragraph-3">
                We don't have our own products to push, but we are experts in
                home loans and negotiating with the banks, so you can always
                trust us to get the most competitive deal possible on your
                behalf. We've been in business for over 18 years, so you can be
                assured we think about the long-term, and how your experience
                might affect our lifetime reputation and relationship in
                property.
              </p>
            </div>
          </div>
          <div className="core-value">
            <img src={core3} alt="core value icon" />
            <div>
              <h5 className="core-value-title">Coverage</h5>
              <p className="paragraph-3">
                You have access to our team of over 30 brokers across Australia.
                And we'll come to you to meet and discuss your needs if you
                prefer. Everything is on your terms and in your time frame.
                That's the way it should be.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoreValues
